const AuthSignConfigFormData = {
  SalesUser: {
    value: "",
    type: "string",
    required: true,
  },
  SalesManager: {
    value: "",
    type: "string",
    required: true,
  },
  PricingCommittee: {
    value: "",
    type: "string",
    required: true,
  },
  DivisionalManager: {
    value: "",
    type: "string",
    required: true,
  },
};

const AuthSignConfigFormErrorData = {
  SalesUser: null,
  SalesManager: null,
  PricingCommittee: null,
  DivisionalManager: null,
};

const setAuthSignConfigFormFieldContent = (
  t,
  formData,
  formError,
  selectedAuthSignConfigId,
  onFieldValueChange,
  onBlurHandler
) => {
  try {
    return [
      [
        {
          fieldtype: "textfield",
          id: "SalesUser",
          type: "string",
          isMandatory: formData.SalesUser.required,
          label: t("createAuthSignConfig.salesUser"),
          placeholder: t("createAuthSignConfig.salesUser"),
          onChange: onFieldValueChange,
          value: formData.SalesUser.value,
          error: formError.SalesUser,
          onBlur: onBlurHandler,
          isDisabled: !!selectedAuthSignConfigId,
        },
        {
          fieldtype: "textfield",
          id: "SalesManager",
          type: "string",
          isMandatory: formData.SalesManager.required,
          label: t("createAuthSignConfig.salesManager"),
          placeholder: t("createAuthSignConfig.salesManager"),
          onChange: onFieldValueChange,
          value: formData.SalesManager.value,
          error: formError.SalesManager,
          onBlur: onBlurHandler,
        },
        {
          fieldtype: "textfield",
          id: "DivisionalManager",
          type: "string",
          isMandatory: formData.DivisionalManager.required,
          label: t("createAuthSignConfig.divisionalManager"),
          placeholder: t("createAuthSignConfig.divisionalManager"),
          onChange: onFieldValueChange,
          value: formData.DivisionalManager.value,
          error: formError.DivisionalManager,
          onBlur: onBlurHandler,
        }
      ],
      [
        {
          fieldtype: "textfield",
          id: "PricingCommittee",
          type: "string",
          isMandatory: formData.PricingCommittee.required,
          label: t("createAuthSignConfig.pricingCommittee"),
          placeholder: t("createAuthSignConfig.pricingCommittee"),
          onChange: onFieldValueChange,
          value: formData.PricingCommittee.value,
          error: formError.PricingCommittee,
          onBlur: onBlurHandler,
        }
      ],
    ];
  } catch (err) {
    alert(err);
  }
};

export { AuthSignConfigFormData, AuthSignConfigFormErrorData, setAuthSignConfigFormFieldContent };
